import { Series } from '@types';

const MUSEUM: Series = {
  id: 'museum',
  name: 'Museum',
};

export default MUSEUM;
